import PropTypes from 'prop-types'

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material'

import useStyles from './styles'

const ClientCentersView = ({ rows }) => {
  const classes = useStyles()
  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table>
        <TableBody>
          {rows.map(row => (
            <TableRow key={row.clientCode}>
              <TableCell width="50%">{row.clientCode}</TableCell>
              <TableCell className="truncate">
                <span>{row.clientName}</span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

ClientCentersView.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      clientCode: PropTypes.string.isRequired,
      clientName: PropTypes.string,
    }),
  ),
}

export default ClientCentersView
